// export * from './SurveyResponsesTable';

import SurveyResponsesTable from './SurveyResponsesTable';

export default SurveyResponsesTable;
